export default __webpack_public_path__ + "static/media/certificado_iso_azul.bedcb25f.png";